import React, { useState } from "react"
import HorizontalStat from "components/elements/HorizontalStat"
import pluralize from "pluralize"
import { LOW_SMS_CREDIT_THRESHOLD } from "utilities/constants"
import Popover from "components/dialogs/Popover"
import { Stack, Text } from "@chakra-ui/react"
import { asNumber } from "utilities/strings"
import Link from "components/elements/Link"

type Props = {
  smsCredits: number
  onClickAddCredits: () => void
}

const CreditCounter = ({ smsCredits, onClickAddCredits }: Props) => {
  const [isOpen, setIsOpen] = useState(false)

  const SMSCreditsAsNumber = asNumber(smsCredits)
  const pluralizedSMSCredits = pluralize("Credit", smsCredits)

  return (
    <Popover
      placement="bottom-end"
      arrow={false}
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      onOpen={() => setIsOpen(true)}
      trigger={(
        <HorizontalStat
          danger={smsCredits < LOW_SMS_CREDIT_THRESHOLD}
          label={pluralizedSMSCredits}
          value={SMSCreditsAsNumber}
          isClickable
        />
      )}
      body={(
        <Stack p={6}>
          <Text fontWeight="semibold">
            {SMSCreditsAsNumber} Message {pluralizedSMSCredits} remaining
          </Text>
          <Text>
            These are available for use across all events in your account.
          </Text>
          <Link onClick={onClickAddCredits}>
            Buy More Message Credits
          </Link>
        </Stack>
      )}
    />
  )
}

export default CreditCounter
